<template>
  <p v-if="dependsOnHost || vars.length" class="variable-hint">
    <template v-if="dependsOnHost">
      {{ options.Lang.variables.depends_on_host || 'Variables here follow the rules of the text the signature is inserted into.' }}
    </template>
    <template v-else>
      {{ options.Lang.variables.empty_here || 'Always empty here:' }}
      <span v-for="key in vars" :key="key" class="variable-hint__key">[{{ key }}]</span>
    </template>
  </p>
</template>

<script>
import { VARIABLES_EMPTY_IN, VARIABLES_DEPEND_ON_HOST } from '../../../../common/templateVariables'

export default {
  name: 'VariableHint',
  props: {
    options: { type: Object, required: true },
    // Editor key as used in AdditionalInformationTab (subject, template, welcomeText, …)
    editorKey: { type: String, required: true },
  },
  computed: {
    vars () {
      return VARIABLES_EMPTY_IN[this.editorKey] || [];
    },
    dependsOnHost () {
      return VARIABLES_DEPEND_ON_HOST.includes(this.editorKey);
    },
  },
}
</script>

<style scoped>
.variable-hint {
  margin: 4px 0 0;
  font-size: 0.85em;
  color: #888;
  font-style: italic;
}
.variable-hint__key {
  font-family: monospace;
  margin-left: 4px;
  font-style: normal;
}
</style>
